export default {
  "@keyframes slide-up": {
    "0%": { opacity: "0", transform: "translateY(40px)" },
    "100%": { opacity: "1", transform: "translateY(0)" },
  },
  "@keyframes close-side-window": {
    "0%": { opacity: "1", transform: "translate3d(0, 0, 0)" },
    "50%": { transform: "translate3d(500px, 0, 0)", opacity: "0.5" },
    "100%": { transform: "translate3d(500px, 0, 0)", opacity: "0" },
  },
  "@keyframes open-side-window": {
    "0%": { opacity: "0", transform: "translate3d(500px, 0, 0)" },
    "50%": { opacity: "1" },
    "100%": { transform: "translate3d(0, 0, 0)", opacity: "1" },
  },
};
